import React from 'react';
import { Dumbbell, Shield, Target, Cross, Eye, RefreshCw, Users } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
const principles = [{
  icon: Shield,
  title: 'RESILIENCE',
  desc: 'Developing thick skin to not allow the challenges to penetrate and defeat you. To ultimately persevere.'
}, {
  icon: Dumbbell,
  title: 'STRENGTH',
  desc: 'Physical and mental fortitude to push through barriers.'
}, {
  icon: Eye,
  title: 'FOCUS',
  desc: 'Once a rhino picks a direction, its unwavering focus charges and does not stop until it reaches its destination or target.'
}, {
  icon: Target,
  title: 'DISCIPLINE',
  desc: "Doing what needs to be done, especially when it's hard."
}, {
  icon: RefreshCw,
  title: 'CONSISTENCY',
  desc: 'Showing up every single day. The compound effect of effort.'
}, {
  icon: Cross,
  title: 'FAITH',
  desc: 'The foundation of true power. Grounded in purpose and integrity, guided by unwavering belief.'
}, {
  icon: Users,
  title: 'ACCOUNTABILITY',
  desc: 'A "Crash" of rhinos are stronger together. And we are stronger together in a community of like-minded believers.'
}];
export function RhinoMindSection() {
  return <section id="principles" className="py-24 bg-rhino-black relative overflow-hidden" data-id="element-112">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-rhino-charcoal/50 to-transparent pointer-events-none" data-id="element-113"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-114">
        <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-115">
          <FadeIn data-id="element-116">
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white tracking-wide mb-8" data-id="element-117">
              THE <span className="text-rhino-gold" data-id="element-118">PRINCIPLES</span>
            </h2>
          </FadeIn>

          {/* Rhino Image */}
          <FadeIn delay={0.15} data-id="element-119">
            <div className="w-full max-w-2xl mx-auto mb-12 rounded-lg overflow-hidden shadow-2xl shadow-rhino-gold/10" data-id="element-120">
              <img src="https://cdn.magicpatterns.com/uploads/uYf9fRL5oxrKgh6Ht8BvZj/1000177797.jpg" alt="Rhino breaking through a wall" className="w-full h-auto object-cover" data-id="element-121" />
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-122">
            <div className="bg-rhino-charcoal p-8 md:p-12 rounded-sm border-l-4 border-rhino-gold shadow-2xl" data-id="element-123">
              <p className="text-lg md:text-xl text-gray-300 leading-relaxed text-left" data-id="element-124">
                "The Rhino Mind is more than a self-help book. It is a
                faith-driven mindset that refuses to live small, refuses to
                stall in life. It is a strategic playbook for anyone tired of
                settling for less than their God-given potential. It is for
                those ready to charge forward with strength, discipline, and
                decisiveness. Learn how to cultivate the mindset required for
                growth and the relentless charge required for victory."
              </p>
            </div>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-125">
          {principles.map((principle, index) => <FadeIn key={index} delay={0.3 + index * 0.08} data-id="element-126">
              <motion.div whileHover={{
            y: -10
          }} className="bg-rhino-charcoal p-8 rounded-sm border border-rhino-grey hover:border-rhino-gold/50 transition-colors h-full group" data-id="element-127">
                <div className="w-14 h-14 bg-rhino-black rounded-sm flex items-center justify-center mb-6 group-hover:bg-rhino-gold/10 transition-colors border border-rhino-grey group-hover:border-rhino-gold/30" data-id="element-128">
                  <principle.icon className="text-rhino-gold w-7 h-7" data-id="element-129" />
                </div>
                <h3 className="text-xl font-heading font-bold text-white mb-3 tracking-wide" data-id="element-130">
                  {principle.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-131">
                  {principle.desc}
                </p>
              </motion.div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}